import { JWT_TOKEN } from 'constants/localStorageKeys'

const isAuthenticated = () => !!localStorage.getItem(JWT_TOKEN)

export default isAuthenticated
